import { Api } from 'utils';

class NewsService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/news',params),
		save: async (params?: any) => Api.createResponse('admin/news/save',params),
		delete: async (params?: any) => Api.createResponse('admin/news/delete',params),
	}

}

export default NewsService;